import React from 'react';
import './DisasterRecoveryOffer.css';
import a from './img1.png';
import b from './img2.png';

const fitItems = [
    'עסקים שמחזיקים מידע קריטי ומערכות חשובות לפעילות.',
    'חברות שלא יכולות להרשות לעצמן השבתה ארוכה או שחזור איטי.',
    'ארגונים שצריכים פתרון גיבוי והתאוששות מסודר יותר.',
    'עסקים שחוששים מתקיפת כופר, מחיקה, כשל תשתיתי או שיבוש שירות.',
    'חברות שצריכות תוכנית DR ולא רק גיבוי בסיסי.',
    'ארגונים בינוניים שצריכים חשיבה פרקטית על המשכיות עסקית.'
];

const problemItems = [
    'יש גיבויים, אבל לא ברור אם אפשר באמת להתאושש מהם בזמן.',
    'אין תוכנית ברורה למה קורה אם מערכת קריטית נופלת.',
    'לא ברור מה חייב לחזור קודם ומה יכול להמתין.',
    'השבתה ארוכה מדי עלולה לפגוע בהכנסות, בשירות ובאמון הלקוחות.',
    'יש חשש מאובדן נתונים בעקבות תקלה, מחיקה או מתקפת כופר.',
    'אין מספיק הפרדה בין סביבת הייצור לבין סביבת הגיבוי.',
    'תהליך השחזור לא מספיק מהיר, מסודר או מוכח.',
    'לא ברור אם הארגון באמת מוכן לאירוע חירום.'
];

const audienceSignals = [
    'אם אתם יודעים שגיבוי לבד לא מספיק, וצריך גם תוכנית התאוששות אמיתית.',
    'אם כל שעה של השבתה אצלכם משמעותית לעסק.',
    'אם אתם מחזיקים מידע או מערכות שלא יכולים להישאר לא זמינים לאורך זמן.',
    'אם אתם רוצים לדעת שבמקרה חירום יש דרך ברורה לחזור לפעילות.',
    'אם אתם צריכים פתרון פרקטי להמשכיות עסקית בלי להכביד על הארגון.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הסיכונים',
        text: 'ממפים את המערכות, הנתונים, התלויות והתרחישים שיכולים להשפיע על הפעילות.'
    },
    {
        number: '02',
        title: 'מיפוי מצב קיים והגדרת עדיפויות',
        text: 'בודקים גיבויים, פערי שחזור, סדרי עדיפויות עסקיים וזמני התאוששות נדרשים.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור להתאוששות',
        text: 'מגדירים אסטרטגיית גיבוי, שחזור והמשכיות שתואמת לצרכים האמיתיים של העסק.'
    },
    {
        number: '04',
        title: 'יישום, בדיקות והמשך שיפור',
        text: 'מלווים את ההטמעה, בודקים מוכנות וממשיכים לחזק את היכולת להתאושש בזמן אמת.'
    }
];

const trustPoints = [
    'ניסיון בתשתיות, ענן, גיבוי והמשכיות עסקית.',
    'גישה פרקטית ולא תאורטית בלבד.',
    'חיבור בין צורך עסקי, הגנת מידע ותהליך התאוששות.',
    'חשיבה על מוכנות אמיתית ולא רק על פתרון על הנייר.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const DisasterRecoveryCloudBackup = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-disaster-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="disaster-recovery-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">התאוששות קריסה וגיבוי לעסקים שצריכים להיות מוכנים לרגע האמת</h2>
                        <p className="lead offer-description">
                            אנחנו עוזרים לעסקים להגן על מידע קריטי, לבנות תהליכי התאוששות ברורים ולקצר את הדרך
                            חזרה לפעילות במקרה של כשל, תקיפה, מחיקה או השבתה.
                        </p>
                        <div className="disaster-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center disaster-main-section">
                    <div className="col-md-6">
                        <h3>גיבוי הוא רק חלק מהתמונה</h3>
                        <p>
                            המטרה היא לא רק לשמור עותק של המידע, אלא לדעת איך לחזור לפעילות בצורה מהירה,
                            מסודרת ובהתאם למה שהעסק באמת צריך קודם.
                        </p>
                        <p>
                            עסקים רבים כבר מחזיקים כלי גיבוי, אבל כשהסביבה גדלה נדרש מערך התאוששות ברור יותר,
                            עם סדרי עדיפויות, הפרדה נכונה ונוהל שאפשר להפעיל בזמן אמת.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="גיבוי והתאוששות לעסקים" className="img-fluid" />
                    </div>
                </div>

                <div className="row align-items-center disaster-secondary-section">
                    <div className="col-md-6">
                        <img src={b} alt="תכנון המשכיות עסקית והתאוששות" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו מספקים פתרונות גיבוי מבוססי ענן, גיבוי מרוחק ומוצפן, תכנון DR,
                            בניית אסטרטגיית שחזור, ושיפור מוכנות להתאוששות מאירועי כשל או שיבוש.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין גיבוי, שחזור, תשתית, אבטחה והמשכיות עסקית,
                            כדי ליצור בסיס אמין יותר להתאוששות מהירה ולצמצום סיכון עסקי.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">פתרונות גיבוי מבוססי ענן ומערכי גיבוי מרוחק.</div>
                            <div className="signal-item">בניית אסטרטגיית שחזור ותוכנית התאוששות מסודרת.</div>
                            <div className="signal-item">שיפור הגנה על נתונים והפרדה בין סביבות.</div>
                            <div className="signal-item">ליווי ביישום, בדיקות מוכנות והמשך שיפור.</div>
                            <div className="signal-item">התאמת רמת ההגנה וההתאוששות לצורך העסקי בפועל.</div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">מה יוצא לכם מזה</h3>
                            <div className="trust-grid">
                                <div className="trust-item">פחות סיכון לאובדן נתונים ופחות חוסר ודאות בזמן משבר.</div>
                                <div className="trust-item">התאוששות מהירה ומסודרת יותר של מערכות קריטיות.</div>
                                <div className="trust-item">פחות זמן השבתה ויותר שליטה על תרחישי חירום.</div>
                                <div className="trust-item">המשכיות עסקית חזקה יותר ושמירה טובה יותר על השירות.</div>
                                <div className="trust-item">בסיס תפעולי ואבטחתי טוב יותר לשחזור ולהגנה על מידע.</div>
                                <div className="trust-item">מוכנות אמיתית לרגע שבו צריך לשחזר, לא רק קבצים מגובים.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם אתם לא רוצים לגלות מאוחר מדי שהגיבוי לא מספיק, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך לגבות, מה חייב להשתחזר ראשון, ואיך בונים מוכנות אמיתית
                                לאירוע חירום בלי להכביד על הפעילות השוטפת.
                            </p>
                            <div className="disaster-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DisasterRecoveryCloudBackup;
